export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/subtract.fda9cf18.svg","height":22,"width":21};